var map = {
	"./Logo.svg": 64874,
	"./default.svg": 99220,
	"./icons": 17691,
	"./icons.js": 17691,
	"./marker": 29513,
	"./marker.js": 29513,
	"./menu-collapsed.svg": 89607,
	"./menu-expanded.svg": 20530,
	"./nav-color.svg": 81207,
	"./nav-messages.svg": 18313,
	"./nav-notifications.svg": 82127,
	"./nav-search.svg": 5034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;